<template>
  <v-container fill-height>
    <v-row align="center" justify="center">
      <v-col cols="auto" class="text-center">
        <div>
          <img style="width: 150px" src="../images/maskot_maintenance_w-300.png" alt="">
          <h2>Page Under Construction</h2>
          <p class="text-subtitle1 mt-2">New content coming soon.</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: "UnderConstruction",
};
</script>
